/**
 * The `apiboo://` URI builder, mirroring `src-tauri/src/mcp/resources.rs`.
 *
 * Two implementations of one grammar is a drift risk, so it is kept to
 * builders only — Rust does all the PARSING (it is the side that receives a
 * URI from the network), and JS only ever emits. `mcpResourceUris.test.js`
 * pins the two against each other.
 */

function percentEncode(s) {
  return String(s).replace(/[^A-Za-z0-9\-_.~]/g, (c) =>
    `%${c.charCodeAt(0).toString(16).toUpperCase().padStart(2, '0')}`
  );
}

export function documentUri(wireScope, docId) {
  return `apiboo://documents/${percentEncode(wireScope)}/${percentEncode(docId)}`;
}

export function boardUri(wireScope, boardId) {
  return `apiboo://boards/${percentEncode(wireScope)}/${percentEncode(boardId)}`;
}

/**
 * One `resources/list` entry. `annotations` are added in Rust, from the
 * record's `updated_at` — a client sorting by recency is the whole point of
 * exposing these as resources rather than as bare tool output.
 */
export function resourceEntry({ uri, name, title, description, mimeType, size }) {
  const entry = { uri, name, mimeType };
  if (title) entry.title = title;
  if (description) entry.description = description;
  if (typeof size === 'number') entry.size = size;
  return entry;
}

/**
 * A `resource_link` content block — the clean way for a list tool to hand back
 * a pointer the client can then `resources/read`, instead of inlining a body
 * nobody asked for. One extra object per row.
 */
export function resourceLink(uri, name) {
  return { type: 'resource_link', uri, name };
}
